/**
 * AiButton — the small "✨ Suggest …" button used to trigger an AI helper.
 * Stays visually quiet: pale slate background, no big colored CTA.
 */

import React from 'react';

export default function AiButton({ label, onClick, loading = false, disabled = false }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading || disabled}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-slate-50 ring-1 ring-slate-200 text-slate-700 hover:bg-white text-[12px] disabled:opacity-50 disabled:cursor-not-allowed transition"
    >
      <span aria-hidden>{loading ? '…' : '✨'}</span>
      <span>{loading ? 'Thinking…' : label}</span>
    </button>
  );
}
